import React from 'react'
import PropTypes from 'prop-types'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const UploadError = ({ text = 'Upload Error' }) => (
  <ErrorContainer>
    <ExclamationCircleFilled /> {text}
  </ErrorContainer>
)

const ErrorContainer = styled.div`
  color: red;
  font-size: 12px;

  svg {
    font-size: 12px;
  }
`

UploadError.propTypes = {
  text: PropTypes.string
}

export default UploadError
